import { render, staticRenderFns } from "./whatsapp-button.vue?vue&type=template&id=18a7bc10"
import script from "./whatsapp-button.vue?vue&type=script&lang=js"
export * from "./whatsapp-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports